module.exports = __webpack_public_path__ + "img/005.86f0a5de.jpg";